import { z } from 'zod'

export const SocketEventBaseSchema = z.object({
  event: z.literal('test' as string),
})
